import React from 'react';
import { Box, List, ListItemButton } from '@mui/material';

function CreateProxy({
  node,
  handleClose,
  memberRecords,
  onAddProxy,
  setError
}) {
  const getPerson = (x) => {
    if (!x) return undefined;
    if (x?.pid) return x;
    if (x?.data?.pid) return x.data;
    return undefined;
  };

  const menuPerson = getPerson(node);

  const createProxyNow = () => {
    if (!menuPerson?.pid) {
      setError?.('Create Proxy failed: selected node pid missing.');
      return;
    }

    const original = (memberRecords || []).find(
      (p) => p.pid === menuPerson.pid
    );
    const spouseIds = Array.isArray(original?.spouseIds)
      ? original.spouseIds
      : [];

    if (!spouseIds.length) {
      setError?.('Create Proxy: selected node has no spouse to proxy against.');
      return;
    }

    const latestSpousePid = spouseIds[spouseIds.length - 1];

    onAddProxy?.({ originalPid: original.pid, proxyId: latestSpousePid });
    handleClose?.();
  };

  return (
    <Box>
      <List>
        <ListItemButton onClick={createProxyNow}>Create Proxy</ListItemButton>
      </List>
    </Box>
  );
}

export default CreateProxy;
